exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news[data-v-7baec284]{padding:0 1rem;width:80%;border-right:2px solid rgba(0,0,0,.2)}@media (max-width:768px){.news[data-v-7baec284]{width:100%;border-style:none;padding-left:0;padding-right:0}}.news main[data-v-7baec284]{margin-bottom:4rem}.news main h1[data-v-7baec284]{font-size:1.875rem}.news main h3[data-v-7baec284]{margin-bottom:1.25rem;font-size:1.5rem}.news main .data[data-v-7baec284]{margin-bottom:3rem}.news main .image[data-v-7baec284]{-o-object-position:center;object-position:center}.news main .text[data-v-7baec284]{margin-top:1rem}", ""]);

// exports
